export const DASHBOARD_BASE_URL =
  import.meta.env.YOUAUX_DASHBOARD_BASE_URL || "https://app.youaux.com";
export const DASHBOARD_SIGNIN_URL = `${DASHBOARD_BASE_URL}/auth/signin`;
export const DASHBOARD_SIGNUP_URL = `${DASHBOARD_BASE_URL}/auth/signup`;

// Cloudflare Pages/Workers: set VITE_CONTACT_ENDPOINT in environment variables.
// Falls back to a placeholder Worker URL for local/dev if not provided.
export const CONTACT_ENDPOINT =
  import.meta.env.YOUAUX_CONTACT_FORM_ENDPOINT ||
  "https://contact.youauxentertainment.workers.dev/";
